// extracted by mini-css-extract-plugin
export default {"description":"AskInvite_description__0Q4oQ"};